module.exports = __webpack_public_path__ + "static/img/logo2.6f701d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo2.png
// module id = 8isl
// module chunks = 1